module.exports = __webpack_public_path__ + "img/withdrawal-processing.7a9bea72.svg";